import { computed } from 'vue';
import { usePermissionsService } from '@/composables/usePermissionsService';
import { usePhysiciansStore } from '@/stores/physicians';
import { useOrdersStore } from "@/stores/orders";

export function useOrdersGridVisibility() {
  const permissions = usePermissionsService();
  const physiciansStore = usePhysiciansStore();
  const ordersStore = useOrdersStore();

  const isSearchingByPhysician = computed(() => {
    const physician = physiciansStore.physician;
    return physician?.userId !== "" && physician?.userId !== null;
  });

  const isSearchingByOrderId = computed(() => {
    return ordersStore.searchOrderId !== "" && ordersStore.searchOrderId !== null;
  });

  const isSearchingByCegatId = computed(() => {
    return ordersStore.searchCegatId !== "" && ordersStore.searchCegatId !== null;
  });

  const showOrdersGrid = computed(() => {
    if (permissions.hasOrderReadAllPermission) {
      return isSearchingByPhysician.value || isSearchingByOrderId.value || isSearchingByCegatId.value;
    }
    return permissions.hasOrderReadPermission;
  });

  const showInternalToolbar = computed(() => {
    return permissions.hasOrderReadAllPermission || permissions.hasOrderReadCountryPermission;
  });

  return {
    isSearchingByPhysician,
    showOrdersGrid,
    showInternalToolbar,
    isSearchingByOrderId,
    isSearchingByCegatId,
  };
}
